import { getOwnerClinic, show, store, updateConclusionLogo, destroyConclusionLogo, storeConclusionLogo, update, destroy } from '../../../api/ownerClinic';

export const actions = {

    getOwnerClinic({ commit }, params = {}) {
        return new Promise((resolve, reject) => {
            getOwnerClinic(params).then(res => {
                commit("SET_MODEL", res.data.data.owner);
                commit("SET_CONCLUSION_LOGO_MODEL", res.data.data.ownerConclusionLogo);
                commit("SET_PHONE_NUMBERS", res.data.data.grouped_phone_numbers);
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },

    show({commit}) {
        return new Promise((resolve, reject) => {
            show().then(res => {
                commit("SET_MODEL", res.data.data);
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },

    store({ commit }, data) {
        return new Promise((resolve, reject) => {
            store(data).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },

    storeConclusionLogo({ commit }, data) {
        return new Promise((resolve, reject) => {
            storeConclusionLogo(data).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },

    update({ commit }, data) {
        return new Promise((resolve, reject) => {
            update(data).then(res => {
                commit("SET_MODEL", res.data.data.owner);
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },

    updateConclusionLogo({ commit }, data) {
        return new Promise((resolve, reject) => {
            updateConclusionLogo(data).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },

    destroy({ commit }, id) {
        return new Promise((resolve, reject) => {
            destroy(id).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },

    destroyConclusionLogo({ commit }, id) {
        return new Promise((resolve, reject) => {
            destroyConclusionLogo(id).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },

    refreshData({ commit }) {
        return new Promise((resolve, reject) => {
            commit("REFRESH");
            resolve()
        })
    },

    empty({ commit }) {
        return new Promise((resolve, reject) => {
            commit("EMPTY_MODEL");
            resolve()
        })
    },
}
